import { apiClient, omrehBaseClient } from "./client";

const GetRegionDropDown = () => {
    return apiClient
        .get("/StaticVariables/GetRegionDropDown");
}

const GetPriceGroupDropDown = () => {
    return apiClient
        .get("/StaticVariables/GetPriceGroupDropDown");
}

const GetAirLineTypeDropDown = () => {
    return omrehBaseClient
        .get("/StaticVariables/GetAirLineTypeDropDown");
}
const GetArabicCityConsistencyDropDown = () => {
    return apiClient
        .get("/StaticVariables/GetArabicCityConsistencyDropDown");
}

const GetAppLogicCodeDropDown = () => {
    return apiClient
        .get("/StaticVariables/GetAppLogicCodeDropDown");
}

const GetCurrentDateTime = () => {
    return apiClient
        .get("/StaticVariables/GetCurrentDateTime");
}
const staticVariablesApi = {
    GetRegionDropDown, GetPriceGroupDropDown, GetAirLineTypeDropDown, GetArabicCityConsistencyDropDown,
    GetAppLogicCodeDropDown, GetCurrentDateTime
}

export default staticVariablesApi